import * as THREE from 'three'
import { Scheduler } from './engine/scheduler'

const HIT_COLOR = 0xff1a1a
const RESPAWN_DELAY_MS = 1200

const raycaster = new THREE.Raycaster()
const centerScreen = new THREE.Vector2(0, 0)

/**
 * Hitscan raycast from camera center; flashes and briefly despawns the first target
 * hit. Respawn is scheduled via the engine Scheduler (driven by the game's Clock)
 * rather than setTimeout, so it stays deterministic under the test-mode ManualClock.
 */
export function fireHitscan(camera: THREE.Camera, targets: THREE.Mesh[], scheduler: Scheduler) {
  raycaster.setFromCamera(centerScreen, camera)
  const hits = raycaster.intersectObjects(targets, false)
  if (hits.length === 0) return

  const target = hits[0].object as THREE.Mesh
  const material = target.material as THREE.MeshStandardMaterial
  const originalColor = material.color.clone()
  const originalScale = target.scale.clone()

  material.color.setHex(HIT_COLOR)
  target.scale.setScalar(0.001)

  scheduler.schedule(RESPAWN_DELAY_MS, () => {
    material.color.copy(originalColor)
    target.scale.copy(originalScale)
  })
}
